import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/auth";
import { Search as SearchIcon } from "lucide-react";

export default function GlobalSearch() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    if (q.length < 2) { setResults([]); return; }
    const t = setTimeout(() => {
      api.get(`/admin/search?q=${encodeURIComponent(q)}`).then(r => setResults(r.data.results || []));
    }, 200);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="relative">
      <div className="flex items-center gap-2 bg-black border border-white/10 px-3 py-1.5">
        <SearchIcon size={14} className="text-zinc-500"/>
        <input value={q} onChange={e => { setQ(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)}
          placeholder="Search everything…"
          className="bg-transparent outline-none text-sm w-52" data-testid="admin-global-search"/>
      </div>
      {open && results.length > 0 && (
        <div className="absolute right-0 top-full mt-2 w-96 card-surface z-50 max-h-96 overflow-y-auto">
          {results.map((r, i) => (
            <button key={`${r.kind}-${r.path}-${r.title}`} onClick={() => { nav(r.path); setOpen(false); setQ(""); }}
              className="w-full text-left px-4 py-2 hover:bg-white/5 border-b border-white/5 last:border-0 flex items-center justify-between text-sm">
              <span className="truncate">{r.title || "—"}</span>
              <span className="text-zinc-500 text-xs uppercase tracking-widest ml-2">{r.kind}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
